import env from "../../../../config/env";
import { AxiosInstance } from "axios";
import { action, makeAutoObservable } from "mobx";
import http from "../../../../services/http";
import { ServiceResult } from "../../../../types/general-types";
import {
  ChangePasswordRenewalRequestDto,
  CheckPasswordRenewalStatusRequestDto,
  CheckPasswordRenewalStatusResponseDto,
  PasswordRenewalChangeResponseDto,
  PasswordRenewalValidateRequestDto,
  PasswordRenewalValidateResponseDto,
  SendPasswordRenewalOtpRequestDto,
  SendPasswordRenewalOtpResponseDto,
} from "./types";
const { API_BASE_URL } = env;

class MandatoryPasswordRenewalStore {
  static readonly id: string = "MandatoryPasswordRenewalStore";
  readonly _apiBaseURL: string = "password-renewal";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }

  @action.bound async CheckStatus(
    params: CheckPasswordRenewalStatusRequestDto
  ) {
    const response: ServiceResult<CheckPasswordRenewalStatusResponseDto> =
      await (
        await this.api.post(`/${this._apiBaseURL}/check-status`, params)
      ).data;
    return response;
  }

  @action.bound async Validate(params: PasswordRenewalValidateRequestDto) {
    const response: ServiceResult<PasswordRenewalValidateResponseDto> = await (
      await this.api.post(`/${this._apiBaseURL}/validate`, params)
    ).data;
    return response;
  }

  @action.bound async SendOtp(params: SendPasswordRenewalOtpRequestDto) {
    const response: ServiceResult<SendPasswordRenewalOtpResponseDto> = await (
      await this.api.post(`/${this._apiBaseURL}/send-otp`, params)
    ).data;
    return response;
  }

  @action.bound async ChangePassword(
    params: ChangePasswordRenewalRequestDto
  ) {
    const response: ServiceResult<PasswordRenewalChangeResponseDto> = await (
      await this.api.post(`/${this._apiBaseURL}/change`, params)
    ).data;
    return response;
  }
}

export default MandatoryPasswordRenewalStore;
